import React, { useState, useEffect } from 'react';

export default function ComposeBox({ onPostSubmit, showToast, defaultComments = true }) {
  const [text, setText] = useState('');
  const [allowComments, setAllowComments] = useState(defaultComments);
  const [audience, setAudience] = useState('Everyone'); // Everyone, Connections, Only Me
  const [imageAttached, setImageAttached] = useState(false);
  const [linkAttached, setLinkAttached] = useState(false);

  // Force local state to sync when the parent's data finishes loading
  useEffect(() => {
    setAllowComments(defaultComments);
  }, [defaultComments]);

  const MAX_CHARS = 500;

  const handleAudienceCycle = () => {
    if (audience === 'Everyone') setAudience('Connections');
    else if (audience === 'Connections') setAudience('Only Me');
    else setAudience('Everyone');
  };

  const handlePublish = () => {
    if (!text.trim() && !imageAttached && !linkAttached) {
      showToast('Cannot publish an empty post!');
      return;
    }

    // Build standard payload structurally matching the Express/Redis pipeline
    const newPostPayload = {
      text: text,
      allowComments: allowComments,
      audience: audience,
      hasImage: imageAttached,
      hasLink: linkAttached,
      timestamp: new Date().toISOString()
    };

    onPostSubmit(newPostPayload);

    // Clear ALL dynamic states, including comments and audience!
    setText('');
    setImageAttached(false);
    setLinkAttached(false);
    setAllowComments(defaultComments);
    setAudience('Everyone');
  };
    

  return (
    <div className="compose-box">
      <div className="compose-header">
        <div className="compose-av">🎨</div>
        <textarea 
          className="compose-textarea" 
          id="compose-text" 
          placeholder="Share a thought, update, or creative insight..." 
          maxLength={MAX_CHARS}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>

      {/* Replaced conditional unmounting with display: none to perfectly match HTML layout flow */}
      <div id="link-preview-wrap" style={{ display: linkAttached ? 'block' : 'none' }}>
        <div className="link-preview">
          <div className="lp-thumb">🔗</div>
          <div style={{ flex: 1 }}>
            <div className="lp-title">Afrofuturism & Brand Identity — Design Week</div>
            <div className="lp-url">designweek.africa/afrofuturism-2026</div>
          </div>
          <button className="lp-close" onClick={() => setLinkAttached(false)}>✕</button>
        </div>
      </div>

      <div id="img-preview-wrap" style={{ display: imageAttached ? 'block' : 'none' }}>
        <div className="img-preview">
          <div className="img-preview-inner">🖼️</div>
          <button className="img-remove" onClick={() => setImageAttached(false)}>✕</button>
        </div>
      </div>

      <div className="compose-footer">
        <div className="compose-tools">
          <button className="compose-tool" title="Add image" onClick={() => { setImageAttached(true); showToast('Image attached'); }}>🖼️</button>
          <button className="compose-tool" title="Add link" onClick={() => setLinkAttached(true)}>🔗</button>
          <button className="compose-tool" title="Tag people" onClick={() => showToast('People tagging coming soon')}>@</button>
          <button className="compose-tool" title="Add topic" onClick={() => showToast('Topic tagging coming soon')}>#</button>
        </div>
        <div className="compose-actions">
          <div className={`char-count ${text.length >= MAX_CHARS ? 'limit-reached' : ''}`} id="char-count">
            {text.length}/{MAX_CHARS}
          </div>
          
          {/* Overriding marginTop to 0 so it aligns perfectly with the char count and post button */}
          <div className="compose-opts" style={{ marginTop: 0, display: 'flex', gap: '8px' }}>
            <button 
              className={`compose-opt ${!allowComments ? 'disabled-state' : ''}`} 
              onClick={() => setAllowComments(!allowComments)}
            >
              💬 Comments {allowComments ? 'on' : '🔒 off'}
            </button>
            <button className="compose-opt" onClick={handleAudienceCycle}>
              🌍 {audience}
            </button>

            
          </div>
          
          <button className="btn btn-primary btn-sm" onClick={handlePublish}>Post</button>
        </div>
      </div>
    </div>
  );
}